export type TVillageOffersType = 'builder' | 'resaleAndBuilder' | 'resale';

export const PRICE_DISCLAIMER_TEXT_MAP: { [key in TVillageOffersType]: string } = {
  builder: 'Условия покупки указаны для первичной недвижимости напрямую от застройщиков',
  resaleAndBuilder:
    'Условия покупки указаны для первичной и вторичной недвижимости от застройщиков, агентов и собственников',
  resale: 'Условия покупки указаны для вторичной недвижимости от агентов и собственников',
};
